/* eslint-disable quotes */
import {
  Color,
  ColorSchema,
  ColorStatus,
} from "themes/interfaces";

export default {
  status: {
    warning: { color: "#FEDB60", text: "#404040" } as ColorSchema,
    success: { color: "#57A75B", text: "#ffffff" } as ColorSchema, // #61B3A8
    error: { color: "#CF4F4F", text: "#ffffff" } as ColorSchema, // "#E15858"
    info: { color: "#4F8FCF", text: "#ffffff" } as ColorSchema,
  } as ColorStatus,
  black: "#000000",
  white: "#FFFFFF"
} as Color;
